<h2 mat-dialog-title>Welcome {{ name }}</h2>
<div mat-dialog-content>
  <p>
    <strong>
      Your library card {{ expireText }} on <span class="red">{{ expireDate }}</span
      >. Please contact the library for assistance
    </strong>
  </p>
</div>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close tabindex="-1" type="button">Close</button>
</div>
